// @ts-nocheck
import Galeria01 from "../images/Galery/Galeria01.jpg";
import Galeria02 from "../images/Galery/Galeria02.jpg";
import Galeria03 from "../images/Galery/Galeria03.jpg";

export const GaleryList = [
  {
    id: 1,
    title: "Transforme seu momento de autocuidado",
    imagealt: "Imagem do produto principal",
    imagesrc: Galeria01,
    producttype: "geleias_de_banho",
  },
  {
    id: 2,
    title: "Toque de alma no ambiente",
    imagealt: "Imagem do produto lateral 1",
    imagesrc: Galeria02,
    producttype: "velas_container",
  },
  {
    id: 3,
    title: "Presenteie quem você ama",
    imagealt: "Imagem do produto lateral 2",
    imagesrc: Galeria03,
    producttype: "joias_de_resina",
  },
];
